<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="EnvirosunDeltaSolSll_1d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import EnvirosunDeltaSolSll_1d00 from '@/device-products/EnvirosunDeltaSolSll_1d00.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: EnvirosunDeltaSolSll_1d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
